import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./modal.scss";
import { useUserAuthentication } from "../../utils/utils";
import { RecommandationTableTwo } from "../../screens/Mapping/AttributeEnrichment/RecommendationTableTwo";
import { Recommendation_Model_Mock_Data } from "../../utils/MockDataTemplateMapping";
import Loader from "../Loader/Loader";

export default function RecommandationModal(props) {
  const { sourceData, updateSourceInputs, user, updateAlert } = props;
  const { login } = useUserAuthentication();
  const Total_Model_List =
    sourceData?.data?.dropdown?.recommendation_details
      ?.recommendation_modal_column_list?.models_meta_data ?? {};
  const [open, setOpen] = useState(props.openModel || false);
  const [actualData, setActualData] = useState(props.actualData || []);
  const [tableColumnList, setTableColumnList] = useState(
    sourceData?.data?.dropdown?.recommendation_details
      ?.recommendation_modal_column_list?.initial_header_column_list ?? []
  );
  const [allModelData, setAllModelData] = useState();
  const [loading, setLoading] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [rowHasError, setRowHasError] = useState({
    status: false,
    message: "",
  });
  const SKU_DESCRIPTION_NAME =
    sourceData?.data?.dropdown?.recommendation_details
      ?.sku_description_column_name || "";
  const PRIMARY_COLUMN = sourceData?.data?.dropdown?.table_primary_key || "";
  const TABLE_HEADER_ALL_COLUMN_LIST =
    sourceData?.data?.dropdown?.recommendation_details
      ?.recommendation_modal_column_list?.all_header_column_list ?? [];

  const handleClose = () => {
    setOpen(false);
    props.closeModel();
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
  };

  const getResponseWithJobId = async (url) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response.status === 401) {
          setLoading(false);
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          setLoading(false);
          setRowHasError({
            status: true,
            message: `Unexpected error occured. Please try again later`,
          });
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      return await response.json();
    } catch (err) {
      setLoading(false);
      updateAlert({
        open: true,
        message: `${
          err.message || "Unexpected error occured. Please try again later"
        }`,
        severity: "error",
        closeFlag: true,
      });
      setRowHasError({
        status: true,
        message: `${
          err.message || "Unexpected error occured. Please try again later"
        }`,
      });
      return null;
    }
  };

  const validateResponse = async (response, jobId) => {
    if (!response) {
      setLoading(false);
      updateAlert({
        open: true,
        message: `Response not found. Please try again later or contact support if the issue persists.`,
        severity: "warning",
        closeFlag: true,
      });
      setRowHasError({
        status: true,
        message:
          "Response not found. Please try again later or contact support if the issue persists.",
      });
      return;
    }

    if (response?.status?.failed && response?.status?.failed.length > 0) {
      setLoading(false);
      updateAlert({
        open: true,
        message: `Process failed. Please try again or contact support if the issue persists.`,
        severity: "warning",
        closeFlag: true,
      });
      setRowHasError({
        status: true,
        message:
          "Process failed. Please try again or contact support if the issue persists.",
      });
      return;
    }

    // queued or running → poll again after 2s
    if (
      response?.status?.queued?.length > 0 ||
      response?.status?.running?.length > 0
    ) {
      const statusMsg =
        response?.status?.queued?.length > 0
          ? "Data process is in Queue"
          : "Processing the data. Please wait for some time";

      setLoaderMessage(statusMsg);

      updateAlert({
        open: true,
        message: statusMsg,
        severity: "info",
        closeFlag: true,
      });

      const url = `${
        sourceData?.data?.dropdown?.recommendation_details?.recommendation_url
      }/predictions/jobById?id=${jobId || ""}`;

      setTimeout(async () => {
        const nextResponse = await getResponseWithJobId(url);
        validateResponse(nextResponse, jobId);
      }, 10000);

      return;
    }

    // success → transform response
    const ALL_MODEL_DATA = Object.keys(response.data || {}).reduce(
      (acc, modelKey) => {
        let Random_ID = 0;
        const updatedItems = response.data[modelKey].map((item) => ({
          ...item,
          model_name: modelKey,
          item_ID: Random_ID++,
          isEditing: false,
        }));
        acc[modelKey] = updatedItems;
        return acc;
      },
      {}
    );

    // Sort Data based on best Score
    setAllModelData(ALL_MODEL_DATA);
    setTableColumnList(
      sourceData?.data?.dropdown?.recommendation_details
        ?.recommendation_modal_column_list?.all_header_column_list ?? []
    );

    try {
      const predictUrl = `${sourceData?.data?.dropdown?.recommendation_details?.recommendation_url}/predictions/acknowledge`;
      const body = { jobIds: [jobId] };
      const response = await fetch(predictUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response.status === 401) {
          setLoading(false);
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          setLoading(false);
          setRowHasError({
            status: true,
            message: `Unexpected error occured. Please try again later`,
          });
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `${
          err.message || "Unexpected error occured. Please try again later"
        }`,
        severity: "error",
        closeFlag: true,
      });
      setRowHasError({
        status: true,
        message: `Unexpected error occured. Please try again later`,
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getAIRecommandation = async (Actual_Data) => {
    setLoading(true);
    setLoaderMessage("Processing the Data, Please wait...");

    const MODEL_NAME = sourceData.current_category;
    const DATASET_NAME = sourceData?.current_source?.toLowerCase() || "";
    const parts = MODEL_NAME.split("_"); // ["RB", "GI", "COMBINED", "AU"]
    const COUNTRY_CODE = parts[parts.length - 1].toLowerCase(); // au
    const CMU = parts.slice(1, -1).join("").toLowerCase(); // gicombined

    const TARGET_MODEL_NAME = `sku_description_${DATASET_NAME}_${COUNTRY_CODE}_${CMU}_doses_calculation`;
    const TARGET_VALUE_LABEL = SKU_DESCRIPTION_NAME;

    const predictUrl = `${
      sourceData?.data?.dropdown?.recommendation_details?.recommendation_url
    }/predictions/predict?userId=${user?.mail || ""}&username=${
      user?.displayName || ""
    }&input=sku_description`;

    const requestBody = Actual_Data.map((item) => ({
      [TARGET_MODEL_NAME]: item.rowData[TARGET_VALUE_LABEL] || "",
    }));

    let error_message = "";
    let statusCode = "";

    try {
      const response = await fetch(predictUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response?.status === 401) {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          setLoading(false);
          login();
          return;
        }

        if (response?.status === 400) {
          setLoading(false);
          statusCode = "400";
          error_message =
            "Model not configured for this CMU. Please try for available CMU's";
          throw new Error(
            `Model not configured for this CMU. Please try for available CMU's`
          );
        }

        setLoading(false);
        setRowHasError({
          status: true,
          message: `Unexpected error occured. Please try again later`,
        });
        throw new Error(`Unexpected error occured. Please try again later`);
      }

      const data = await response.json();
      validateResponse(data, data.jobId);
    } catch (err) {
      setLoading(false);
      if (statusCode === "400") {
        updateAlert({
          open: true,
          message: `${
            error_message || "Unexpected error occured. Please try again later"
          }`,
          severity: "error",
          closeFlag: true,
        });
        setRowHasError({
          status: true,
          message: `${
            error_message || "Unexpected error occured. Please try again later"
          }`,
        });
      } else {
        updateAlert({
          open: true,
          message: `${
            err.message || "Unexpected error occured. Please try again later"
          }`,
          severity: "error",
          closeFlag: true,
        });
        setRowHasError({
          status: true,
          message: `${
            err.message || "Unexpected error occured. Please try again later"
          }`,
        });
      }
    }
  };

  const handleOverride = () => {
    const UpdatedActualData = actualData.map((rowData) => {
      const recommended = sourceData.recommendedModel?.find(
        (item) => rowData.item_Id === item.rowData.item_Id
      );

      if (recommended && recommended.selectedAttributes?.length > 0) {
        // Build updated record with selected attributes from bestScoreModel
        const updatedAttributes = recommended.selectedAttributes
          .filter((col) => col.name !== "select_all")
          .reduce((acc, attr) => {
            acc[attr.name] = recommended.bestScoreModel?.[attr.name] ?? null;
            return acc;
          }, {});

        return {
          ...rowData,
          rowData: {
            ...rowData.rowData,
            ...updatedAttributes,
          },
        };
      }
      return { ...rowData };
    });
    setActualData(UpdatedActualData);
    updateSourceInputs("actualData", UpdatedActualData);
  };

  const handleOnSave = () => {
    if (
      sourceData?.recommendedModel &&
      sourceData?.recommendedModel.length === 0
    ) {
      updateAlert({
        open: true,
        message: `Please make any changes to save the records`,
        severity: "warning",
        closeFlag: true,
      });
      return;
    }

    const SORTED_TABLE_HEADER_COLUMN_LIST =
      sourceData?.get_recommendation_for_all_rows
        ? TABLE_HEADER_ALL_COLUMN_LIST
        : tableColumnList;
    // Step 1: Update mapped data with recommended values
    const Updated_Mapped_Data =
      sourceData.current_mapped_data.map((record) => {
        const recommended = sourceData.recommendedModel.find(
          (rec) => rec.rowData.item_Id === record.item_Id
        );

        if (!recommended) return record;

        let finalData = {};
        SORTED_TABLE_HEADER_COLUMN_LIST.forEach((tabData) => {
          const Is_Value_Changed = recommended?.selectedAttributes.some(
            (att) => att.name === tabData.name
          );
          const value = recommended?.bestScoreModel?.[tabData.name];
          if (
            Is_Value_Changed &&
            value !== undefined &&
            value !== null &&
            tabData.value !== PRIMARY_COLUMN
          ) {
            finalData[tabData.value] = value;
          }
        });

        return {
          ...record,
          rowData: { ...record.rowData, ...finalData, IS_AI_RECOMMENDED: true },
        };
      }) ?? [];

    // Step 2: Track modified records (only those with changes)
    const Modified_Updated_Records = sourceData?.current_mapped_data
      ?.map((item) => {
        const recommended = sourceData.recommendedModel.find(
          (rec) => rec.rowData.item_Id === item.item_Id
        );

        if (!recommended) return null; // skip if no match

        // Check if any value differs
        const Is_Value_Changed = recommended?.selectedAttributes.some(
          (att) =>
            item?.rowData?.[att.name] !==
            recommended?.bestScoreModel?.[att.name]
        );

        if (!Is_Value_Changed) return null;

        let finalData = {};
        recommended?.selectedAttributes?.forEach((tabData) => {
          const value = recommended?.bestScoreModel?.[tabData.name];
          if (
            value !== undefined &&
            value !== null &&
            tabData.value !== PRIMARY_COLUMN
            // item.rowData[tabData.value] !== value
          ) {
            finalData[tabData.value] = value;
          }
        });

        return {
          [PRIMARY_COLUMN]: item?.rowData?.[PRIMARY_COLUMN] || "",
          ...finalData,
        };
      })
      .filter(Boolean);

    // Step 3: Get updated existing modified record
    const Updated_Existing_Modified_Record = sourceData?.modified_mapped_data
      ?.filter((Existing_Record) =>
        Modified_Updated_Records.some(
          (item) => Existing_Record?.[PRIMARY_COLUMN] === item?.[PRIMARY_COLUMN]
        )
      )
      .map((record) => {
        const existing = Modified_Updated_Records.find(
          (item) => item?.[PRIMARY_COLUMN] === record?.[PRIMARY_COLUMN]
        );
        return { ...record, ...existing };
      });

    // Step 4: Sort record that are new to modified Records
    const New_Modified_Records = Modified_Updated_Records.filter(
      (Existing_Record) =>
        sourceData?.modified_mapped_data?.every(
          (item) => Existing_Record?.[PRIMARY_COLUMN] !== item?.[PRIMARY_COLUMN]
        )
    );

    // Step 5: Merge with existing modified data
    const Final_Modified_Data = [
      ...Updated_Existing_Modified_Record,
      ...New_Modified_Records,
    ];

    const Other_Records =
      sourceData?.modified_mapped_data?.filter(
        (other_record) =>
          !Final_Modified_Data.some(
            (item) => item?.[PRIMARY_COLUMN] === other_record?.[PRIMARY_COLUMN]
          )
      ) ?? [];

    // Step 4: Update state
    updateSourceInputs("current_mapped_data", Updated_Mapped_Data);
    updateSourceInputs("modified_mapped_data", [
      ...Other_Records,
      ...Final_Modified_Data,
    ]);
    handleClose();
    props.setGlobalEdit(true);
    updateAlert({
      open: true,
      message: `Recommendations changes saved succesfully`,
      severity: "warning",
      closeFlag: true,
    });
  };

  useEffect(() => {
    if (!sourceData?.get_recommendation_for_all_rows) {
      if (actualData && actualData.length === 1) {
        // Comment the below code when API Call is enabled
        // const ALL_MODEL_DATA = Object.keys(
        //   Recommendation_Model_Mock_Data
        // ).reduce((acc, modelKey) => {
        //   let Random_ID = 0;
        //   const updatedItems = Recommendation_Model_Mock_Data[modelKey].map(
        //     (item) => {
        //       const updated_Data = {
        //         ...item,
        //         model_name: modelKey,
        //         item_ID: Random_ID,
        //         isEditing: false,
        //       };
        //       Random_ID += 1;
        //       return updated_Data;
        //     }
        //   );
        //   acc[modelKey] = updatedItems;
        //   return acc;
        // }, {});
        // setAllModelData(ALL_MODEL_DATA);
        // setTableColumnList([
        //   ...tableColumnList,
        //   { label: "Score", name: "score", value: `score` },
        //   { label: "Model", name: "model_name", value: `score` },
        //   { label: "Selection", name: "selection", value: `selection` },
        //   { label: "Options", name: "options", value: `options` },
        // ]);
        // setActualData([
        //   {
        //     item_Id: 0,
        //     isEditing: false,
        //     rowData: {
        //       form: "TRIG",
        //       pack_size: "0.5",
        //       segment: "APC",
        //       NIELSEN_ITEM_DESCRIPTION: "sku description one",
        //       sku_size: "0.5",
        //       sub_segment: "Keuche",
        //       unit_of_measure: "L",
        //     },
        //   },
        //   // {
        //   //   item_Id: 1,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "TIN",
        //   //     pack_size: "1.0",
        //   //     segment: "CLEAN",
        //   //     sku_description: "sku description two",
        //   //     sku_size: "1.0",
        //   //     sub_segment: "Bathroom",
        //   //     unit_of_measure: "L",
        //   //   },
        //   // },
        //   // {
        //   //   item_Id: 2,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "POWDER",
        //   //     pack_size: "2.0",
        //   //     segment: "LAUNDRY",
        //   //     sku_description: "sku description three",
        //   //     sku_size: "2.0",
        //   //     sub_segment: "Whitening",
        //   //     unit_of_measure: "KG",
        //   //   },
        //   // },
        //   // {
        //   //   item_Id: 3,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "SOLID",
        //   //     pack_size: "0.75",
        //   //     segment: "KITCHEN",
        //   //     sku_description: "sku description four",
        //   //     sku_size: "0.75",
        //   //     sub_segment: "Dishwashing",
        //   //     unit_of_measure: "L",
        //   //   },
        //   // },
        // ]);
        // updateSourceInputs("actualData", [
        //   {
        //     item_Id: 0,
        //     isEditing: false,
        //     rowData: {
        //       form: "TRIG",
        //       pack_size: "0.5",
        //       segment: "APC",
        //       NIELSEN_ITEM_DESCRIPTION: "sku description one",
        //       sku_size: "0.5",
        //       sub_segment: "Keuche",
        //       unit_of_measure: "L",
        //     },
        //   },
        //   // {
        //   //   item_Id: 1,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "TIN",
        //   //     pack_size: "1.0",
        //   //     segment: "CLEAN",
        //   //     sku_description: "sku description two",
        //   //     sku_size: "1.0",
        //   //     sub_segment: "Bathroom",
        //   //     unit_of_measure: "L",
        //   //   },
        //   // },
        //   // {
        //   //   item_Id: 2,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "POWDER",
        //   //     pack_size: "2.0",
        //   //     segment: "LAUNDRY",
        //   //     sku_description: "sku description three",
        //   //     sku_size: "2.0",
        //   //     sub_segment: "Whitening",
        //   //     unit_of_measure: "KG",
        //   //   },
        //   // },
        //   // {
        //   //   item_Id: 3,
        //   //   isEditing: false,
        //   //   rowData: {
        //   //     form: "SOLID",
        //   //     pack_size: "0.75",
        //   //     segment: "KITCHEN",
        //   //     sku_description: "sku description four",
        //   //     sku_size: "0.75",
        //   //     sub_segment: "Dishwashing",
        //   //     unit_of_measure: "L",
        //   //   },
        //   // },
        // ]);

        // Uncomment the below code when API Call is enabled
        const Sorted_Actual_Data = actualData.map((data) => {
          let Final_Data = {};
          tableColumnList.forEach((tabData) => {
            if (data.rowData[tabData.value] !== undefined) {
              Final_Data[tabData.name] = data.rowData[tabData.value];
            }
          });

          return { ...data, rowData: Final_Data };
        });
        setActualData(Sorted_Actual_Data);
        updateSourceInputs("actualData", Sorted_Actual_Data);
        getAIRecommandation(Sorted_Actual_Data);
      } else {
        const Sorted_Actual_Data = actualData.map((data) => {
          let Final_Data = {};
          tableColumnList.forEach((tabData) => {
            if (data.rowData[tabData.value] !== undefined) {
              Final_Data[tabData.name] = data.rowData[tabData.value];
            }
          });
          return { ...data, rowData: Final_Data };
        });
        setActualData(Sorted_Actual_Data);
        updateSourceInputs("actualData", Sorted_Actual_Data);
        getAIRecommandation(Sorted_Actual_Data);
      }
    } else {
      const Table_Header_name = TABLE_HEADER_ALL_COLUMN_LIST.find(
        (item) => item.name === SKU_DESCRIPTION_NAME
      );
      const Sorted_Actual_Data = sourceData?.fulactualdata.filter((gr_data) => {
        const match = actualData.some(
          (item) =>
            item.rowData[Table_Header_name.value] ===
            gr_data.rowData[SKU_DESCRIPTION_NAME]
        );
        return match;
      });
      setActualData(Sorted_Actual_Data);
      updateSourceInputs("actualData", Sorted_Actual_Data);
    }
  }, []);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"xl"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>AI Recommendations</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {loading && <Loader message={loaderMessage} />}
            {rowHasError.status && !loading && (
              <div style={{ color: "red" }}>{rowHasError.message}</div>
            )}
            {!loading && !rowHasError.status && (
              <RecommandationTableTwo
                allModelData={
                  sourceData?.get_recommendation_for_all_rows
                    ? sourceData?.get_recommendation_all_modal_data
                    : allModelData || []
                }
                TableColumns={
                  sourceData?.get_recommendation_for_all_rows
                    ? TABLE_HEADER_ALL_COLUMN_LIST
                    : tableColumnList
                }
                AllModelsMetaData={Total_Model_List}
                sourceData={sourceData}
                updateSourceInputs={updateSourceInputs}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOverride}>Override</Button>
          <Button onClick={handleOnSave}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
